import {RedPipeService} from "./red-pipe.service";

export const RedPipeInjectables: Array<any> = [
  {
    provide: RedPipeService,
    useClass: RedPipeService,
  },
];
